import { Grid2, lighten, styled } from '@mui/material';

export const SpeechBubble = styled(Grid2)<{ center?: boolean }>(({ theme, center }) => {
	const bgcolor = lighten(theme.palette.borders.secondary, 0.25);

	return {
		backgroundColor: bgcolor,
		padding: theme.spacing(1),
		borderRadius: theme.shape.borderRadius,
		borderBottomRightRadius: center ? theme.shape.borderRadius : 0,
		marginBottom: theme.spacing(1),
		position: 'relative',
		width: center ? 'fit-content' : '100%',
		textWrap: 'pretty',
		'&::after': {
			content: '""',
			position: 'absolute',
			bottom: -10,
			left: center ? 'calc(50% - 10px)' : 'calc(100% - 20px)',
			borderWidth: '10px 10px 0 10px',
			borderStyle: 'solid',
			borderColor: `${bgcolor} transparent transparent transparent`,
		},
	};
});
